import {ValueObject} from '@s-ui/domain'

export class InfoVehicleValueObject extends ValueObject {
  /**
   * @param {Array} params
   * @param {Object} params.items
   * @param {String} params.items.id
   * @param {String} params.items.name
   * */
}
